import _defineProperty from "/Users/lacassiano.sugiyama/Workspace/peloton/git/web-tv/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

/* istanbul ignore file */

/* tslint:disable */

/* eslint-disable */
import { globalImportUrl } from '../core/request';
/**
 * Get a CSV file of a user's workout history
 * Gets the workout history for the specified user and downloads the history as CSV file. For each workout, the downloaded file shows the user's workout time, metrics, and various class details.
 * @param userId
 * @returns any Successful response. Downloads workout history CSV file.
 * @throws ApiError
 */

export var getWorkoutHistoryCsv = function getWorkoutHistoryCsv(api, userId) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var localVarPath = "/api/user/".concat(userId, "/workout_history_csv");
  var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
  var baseOptions;

  if (api.configuration) {
    baseOptions = api.configuration.baseOptions;
  }

  var localVarRequestOptions = _objectSpread(_objectSpread({
    method: 'GET'
  }, baseOptions), options);

  var localVarHeaderParameter = {};
  var localVarQueryParameter = {};
  localVarUrlObj.query = _objectSpread(_objectSpread(_objectSpread({}, localVarUrlObj.query), localVarQueryParameter), options.query); // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943

  delete localVarUrlObj.search;
  localVarRequestOptions.headers = _objectSpread(_objectSpread({}, localVarHeaderParameter), options.headers);
  var localVarAxiosArgs = {
    url: globalImportUrl.format(localVarUrlObj),
    options: localVarRequestOptions
  };
  var axios = api.axios;

  var axiosRequestArgs = _objectSpread(_objectSpread({}, localVarAxiosArgs.options), {}, {
    url: localVarAxiosArgs.url
  });

  return axios.request(axiosRequestArgs);
};
/**
 * Get Workout Summary
 * Get summary statistics for specified workout. This includes statistics such as max power, avg resistance, calories, etc.
 * @param workoutId ID for the workout
 * @returns any Successful response. Shows metrics of the last packet for the workout, if the workout has them, otherwise returns all 0s
 * @throws ApiError
 */

export var getWorkoutSummary = function getWorkoutSummary(api, workoutId) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var localVarPath = "/api/workout/".concat(workoutId, "/v2/summary");
  var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
  var baseOptions;

  if (api.configuration) {
    baseOptions = api.configuration.baseOptions;
  }

  var localVarRequestOptions = _objectSpread(_objectSpread({
    method: 'GET'
  }, baseOptions), options);

  var localVarHeaderParameter = {};
  var localVarQueryParameter = {};
  localVarUrlObj.query = _objectSpread(_objectSpread(_objectSpread({}, localVarUrlObj.query), localVarQueryParameter), options.query); // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943

  delete localVarUrlObj.search;
  localVarRequestOptions.headers = _objectSpread(_objectSpread({}, localVarHeaderParameter), options.headers);
  var localVarAxiosArgs = {
    url: globalImportUrl.format(localVarUrlObj),
    options: localVarRequestOptions
  };
  var axios = api.axios;

  var axiosRequestArgs = _objectSpread(_objectSpread({}, localVarAxiosArgs.options), {}, {
    url: localVarAxiosArgs.url
  });

  return axios.request(axiosRequestArgs);
};
/**
 * Gets a user's time series
 * Returns (workout creation time, workout series value, workout ID) user's workouts sorted by descending creation time This endpoint will return an error is accessed for a private user by someone who does not follow them.
 * @param id
 * @param series Series values to return for each workout.
 * @param after If set, only returns workouts after this epoch date value
 * @param before If set, only returns workouts before this epoch date value
 * @param limit If set, returns a limited number  of workouts up to the limit specified. Default to be 20.
 * @returns any A list of workouts
 * @throws ApiError
 */

export var getPaginatedTimeseries = function getPaginatedTimeseries(api, id, series, after, before, limit) {
  var options = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : {};
  var localVarPath = "/api/user/".concat(id, "/v2/timeseries");
  var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
  var baseOptions;

  if (api.configuration) {
    baseOptions = api.configuration.baseOptions;
  }

  var localVarRequestOptions = _objectSpread(_objectSpread({
    method: 'GET'
  }, baseOptions), options);

  var localVarHeaderParameter = {};
  var localVarQueryParameter = {};

  if (typeof series !== 'undefined') {
    localVarQueryParameter['series'] = series;
  }

  if (typeof after !== 'undefined') {
    localVarQueryParameter['after'] = after;
  }

  if (typeof before !== 'undefined') {
    localVarQueryParameter['before'] = before;
  }

  if (typeof limit !== 'undefined') {
    localVarQueryParameter['limit'] = limit;
  }

  localVarUrlObj.query = _objectSpread(_objectSpread(_objectSpread({}, localVarUrlObj.query), localVarQueryParameter), options.query); // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943

  delete localVarUrlObj.search;
  localVarRequestOptions.headers = _objectSpread(_objectSpread({}, localVarHeaderParameter), options.headers);
  var localVarAxiosArgs = {
    url: globalImportUrl.format(localVarUrlObj),
    options: localVarRequestOptions
  };
  var axios = api.axios;

  var axiosRequestArgs = _objectSpread(_objectSpread({}, localVarAxiosArgs.options), {}, {
    url: localVarAxiosArgs.url
  });

  return axios.request(axiosRequestArgs);
};
/**
 * Gets a user's time series
 * Returns (workout creation time, workout series value, workout ID) user's workouts sorted by descending creation time This endpoint will return an error is accessed for a private user by someone who does not follow them.
 * @param id
 * @param series Series values to return for each workout.
 * @param after If set, only returns workouts after this epoch date value
 * @param before If set, only returns workouts before this epoch date value
 * @param limit If set, returns a limited number  of workouts up to the limit specified. Default to be 20.
 * @returns any A list of workouts
 * @throws ApiError
 */

export var getPaginatedTimeseriesWithUnit = function getPaginatedTimeseriesWithUnit(api, id, series, after, before, limit) {
  var options = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : {};
  var localVarPath = "/api/user/".concat(id, "/v3/timeseries");
  var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
  var baseOptions;

  if (api.configuration) {
    baseOptions = api.configuration.baseOptions;
  }

  var localVarRequestOptions = _objectSpread(_objectSpread({
    method: 'GET'
  }, baseOptions), options);

  var localVarHeaderParameter = {};
  var localVarQueryParameter = {};

  if (typeof series !== 'undefined') {
    localVarQueryParameter['series'] = series;
  }

  if (typeof after !== 'undefined') {
    localVarQueryParameter['after'] = after;
  }

  if (typeof before !== 'undefined') {
    localVarQueryParameter['before'] = before;
  }

  if (typeof limit !== 'undefined') {
    localVarQueryParameter['limit'] = limit;
  }

  localVarUrlObj.query = _objectSpread(_objectSpread(_objectSpread({}, localVarUrlObj.query), localVarQueryParameter), options.query); // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943

  delete localVarUrlObj.search;
  localVarRequestOptions.headers = _objectSpread(_objectSpread({}, localVarHeaderParameter), options.headers);
  var localVarAxiosArgs = {
    url: globalImportUrl.format(localVarUrlObj),
    options: localVarRequestOptions
  };
  var axios = api.axios;

  var axiosRequestArgs = _objectSpread(_objectSpread({}, localVarAxiosArgs.options), {}, {
    url: localVarAxiosArgs.url
  });

  return axios.request(axiosRequestArgs);
};
/**
 * Gets workout's packet data formatted to display graphs
 * Returns summaries showing aggregate statistics for the workout, as well as a list of values for metrics over time. Also includes data about the segments of workout.
 * @param workoutId
 * @param everyN Sampling rate for the packets
 * @param maxGapMeters Maximum gap between GPS coordinates for location data
 * @param includeOutput An override for the iOS app to include output in the workout summaries. In older designs, output was shown in the workout details header. So, to prevent duplication, we removed it from iOS API responses. This flag allows newer clients to request that output be included.
 * @param durationSummaryInSeconds By default, the unit of the "duration" summary is based on the value. If the time is one minute or less, the summary is returned in seconds; if it is greater than a minute, it's returned as a decimal number of minutes. Some devices want to display duration in both minutes and seconds, which is not supported by the format of the display_unit field, so we allow them to have the units always returned in seconds and do the conversion on the client side.
 * @param acceptLanguage Accept language(s) that the user choose on the device.
 * If not included or unsupported, the value will default to en-US.
 * Can be weighted with the quality value syntax.
 *
 * Examples:
 * Accept-Language: de
 * Accept-Language: en-US, en;q=0.5
 * Accept-Language: de-DE, de;q=0.9, en-US, en;q=0.7
 *
 * Specification: https://tools.ietf.org/html/rfc7231#section-5.3.5
 *
 * @returns PerformanceGraphResponse A list of workout performance graphs
 * @throws ApiError
 */

export var getPerformanceGraph = function getPerformanceGraph(api, workoutId, everyN, maxGapMeters, includeOutput, durationSummaryInSeconds, acceptLanguage) {
  var options = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : {};
  var localVarPath = "/api/workout/".concat(workoutId, "/performance_graph");
  var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
  var baseOptions;

  if (api.configuration) {
    baseOptions = api.configuration.baseOptions;
  }

  var localVarRequestOptions = _objectSpread(_objectSpread({
    method: 'GET'
  }, baseOptions), options);

  var localVarHeaderParameter = {};
  var localVarQueryParameter = {};

  if (typeof everyN !== 'undefined') {
    localVarQueryParameter['every_n'] = everyN;
  }

  if (typeof maxGapMeters !== 'undefined') {
    localVarQueryParameter['max_gap_meters'] = maxGapMeters;
  }

  if (typeof includeOutput !== 'undefined') {
    localVarQueryParameter['include_output'] = includeOutput;
  }

  if (typeof durationSummaryInSeconds !== 'undefined') {
    localVarQueryParameter['duration_summary_in_seconds'] = durationSummaryInSeconds;
  }

  localVarHeaderParameter['Accept-Language'] = String(acceptLanguage);
  localVarUrlObj.query = _objectSpread(_objectSpread(_objectSpread({}, localVarUrlObj.query), localVarQueryParameter), options.query); // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943

  delete localVarUrlObj.search;
  localVarRequestOptions.headers = _objectSpread(_objectSpread({}, localVarHeaderParameter), options.headers);
  var localVarAxiosArgs = {
    url: globalImportUrl.format(localVarUrlObj),
    options: localVarRequestOptions
  };
  var axios = api.axios;

  var axiosRequestArgs = _objectSpread(_objectSpread({}, localVarAxiosArgs.options), {}, {
    url: localVarAxiosArgs.url
  });

  return axios.request(axiosRequestArgs);
};
/**
 * Gets user's overview
 * Return user overview including workout counts by fitness discipline,
 * achievements and personal records.
 * 1. List of user's fitness discipline based workout counts, the order of
 * fitness discipline is:
 * Cycling, Running, Circuit. Workout count includes
 * finalized workouts as well as unfinalized ones.
 * If the user has no workouts of that discipline, it will not appear in
 * the list.
 * 2. User's achievements, includes total count and achievements list.
 * The ordered achivements list contains count by achievement templates and
 * achievement template mappings.
 * 3. List of user's fitness discipline based personal records, the order
 * of fitness discipline is:
 * [Aurora Platform] Running, Circuit, Cycling(if user has cycling personal
 * record)
 * [Non-aurora Platform] Cycling, Running(if user has running personal
 * record), Circuit(if user has circuit personal record).
 * Within each fitness discipline, the records are ordered by increasing
 * duration with wrap
 * around, with the first record being the first from the following list
 * that the user has a
 * personal record for: 45 min, 30 min, 15 min, 10 min, 60 min. The records
 * include all the
 * durations that user has a personal record for.
 * Empty list of records within the fitness discipline indicate that there
 * is no personal records for that specific fitness discipline,
 * and clients will decide whether to display that fitness discipline with
 * empty records based on the platform.
 * Notice All aurora content will be hidden if hide aurora toggle is ON.
 * This endpoint will return an error is accessed for a private user by
 * someone who does not follow them.
 * @param id
 * @param version If version is 1, inside the response will have "achievements" ordered by date with maximum 10 items. If not provided, response will have the achievement_count
 * @param include if value includes "recent workouts", indicates query should include recent workouts.
 * @param recentWorkoutsLimit Number of recent workouts to include
 * @param imageType achievement badge image type
 * @param pelotonPlatform Platform the endpoint is called on. This may hide information from the response (class types, fitness disciplines, classes of certain fitness disciplines, etc.) that should not display on this platform. If this has any other effect on the endpoint, it will be noted in the description.
 *
 * @param acceptLanguage Accept language(s) that the user choose on the device.
 * If not included or unsupported, the value will default to en-US.
 * Can be weighted with the quality value syntax.
 *
 * Examples:
 * Accept-Language: de
 * Accept-Language: en-US, en;q=0.5
 * Accept-Language: de-DE, de;q=0.9, en-US, en;q=0.7
 *
 * Specification: https://tools.ietf.org/html/rfc7231#section-5.3.5
 *
 * @returns UserOverview Successful response
 * @throws ApiError
 */

export var getUserOverview = function getUserOverview(api, id, version, include, recentWorkoutsLimit, imageType, pelotonPlatform, acceptLanguage) {
  var options = arguments.length > 8 && arguments[8] !== undefined ? arguments[8] : {};
  var localVarPath = "/api/user/".concat(id, "/overview");
  var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
  var baseOptions;

  if (api.configuration) {
    baseOptions = api.configuration.baseOptions;
  }

  var localVarRequestOptions = _objectSpread(_objectSpread({
    method: 'GET'
  }, baseOptions), options);

  var localVarHeaderParameter = {};
  var localVarQueryParameter = {};

  if (typeof version !== 'undefined') {
    localVarQueryParameter['version'] = version;
  }

  if (typeof include !== 'undefined') {
    localVarQueryParameter['include'] = include;
  }

  if (typeof recentWorkoutsLimit !== 'undefined') {
    localVarQueryParameter['recent_workouts_limit'] = recentWorkoutsLimit;
  }

  if (typeof imageType !== 'undefined') {
    localVarQueryParameter['image_type'] = imageType;
  }

  localVarHeaderParameter['Peloton-Platform'] = String(pelotonPlatform);
  localVarHeaderParameter['Accept-Language'] = String(acceptLanguage);
  localVarUrlObj.query = _objectSpread(_objectSpread(_objectSpread({}, localVarUrlObj.query), localVarQueryParameter), options.query); // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943

  delete localVarUrlObj.search;
  localVarRequestOptions.headers = _objectSpread(_objectSpread({}, localVarHeaderParameter), options.headers);
  var localVarAxiosArgs = {
    url: globalImportUrl.format(localVarUrlObj),
    options: localVarRequestOptions
  };
  var axios = api.axios;

  var axiosRequestArgs = _objectSpread(_objectSpread({}, localVarAxiosArgs.options), {}, {
    url: localVarAxiosArgs.url
  });

  return axios.request(axiosRequestArgs);
};
/**
 * Gets overview of user's activity for a given month
 * Return overview of a given month for a user including workout counts by
 * fitness discipline, aggregate stats and highlights.
 * 1. List of user's fitness discipline based workout counts for the month.
 * The order of fitness discipline is:
 * Cycling, Running, Circuit. Workout count includes
 * finalized workouts as well as unfinalized ones.
 * If the user has no workouts of that discipline, it will not appear in
 * the list.
 * If hide aurora toggle is on and viewed anywhere but on the treadmill,
 * Running and Circuit will not appear.
 * 2. List of user's aggregate stats for the month.
 * 3. List of highlights of the month for that user. Highlights are a list
 * of API-driven data about the selected month.
 * We will start with three: "Best Output", "Favorite Instructor", and
 * "Latest Badges".
 * The schema for a given highlight will always be the same, but which
 * highlights are returned may change.
 * Notice All aurora content will be hidden if hide aurora toggle is ON.
 * This endpoint will return an error is accessed for a private user by
 * someone who does not follow them.
 * @param id
 * @param month Month to get overview for in the format YYYY-MM
 * @param pelotonPlatform Platform the endpoint is called on. This may hide information from the response (class types, fitness disciplines, classes of certain fitness disciplines, etc.) that should not display on this platform. If this has any other effect on the endpoint, it will be noted in the description.
 *
 * @param acceptLanguage Accept language(s) that the user choose on the device.
 * If not included or unsupported, the value will default to en-US.
 * Can be weighted with the quality value syntax.
 *
 * Examples:
 * Accept-Language: de
 * Accept-Language: en-US, en;q=0.5
 * Accept-Language: de-DE, de;q=0.9, en-US, en;q=0.7
 *
 * Specification: https://tools.ietf.org/html/rfc7231#section-5.3.5
 *
 * @returns UserMonthOverview Successful response
 * @throws ApiError
 */

export var getUserMonthOverview = function getUserMonthOverview(api, id, month, pelotonPlatform, acceptLanguage) {
  var options = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};
  var localVarPath = "/api/user/".concat(id, "/overview/month/").concat(month);
  var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
  var baseOptions;

  if (api.configuration) {
    baseOptions = api.configuration.baseOptions;
  }

  var localVarRequestOptions = _objectSpread(_objectSpread({
    method: 'GET'
  }, baseOptions), options);

  var localVarHeaderParameter = {};
  var localVarQueryParameter = {};
  localVarHeaderParameter['Peloton-Platform'] = String(pelotonPlatform);
  localVarHeaderParameter['Accept-Language'] = String(acceptLanguage);
  localVarUrlObj.query = _objectSpread(_objectSpread(_objectSpread({}, localVarUrlObj.query), localVarQueryParameter), options.query); // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943

  delete localVarUrlObj.search;
  localVarRequestOptions.headers = _objectSpread(_objectSpread({}, localVarHeaderParameter), options.headers);
  var localVarAxiosArgs = {
    url: globalImportUrl.format(localVarUrlObj),
    options: localVarRequestOptions
  };
  var axios = api.axios;

  var axiosRequestArgs = _objectSpread(_objectSpread({}, localVarAxiosArgs.options), {}, {
    url: localVarAxiosArgs.url
  });

  return axios.request(axiosRequestArgs);
};
/**
 * Gets the ride's info used by clients to display a locally cached version of the performance graph
 * @param id
 * @param durationSummaryInSeconds By default, the unit of the "duration" summary is seconds. Some devices want to display duration in both minutes and seconds, which is not supported by the format of the display_unit field, so we allow them to have the units always returned in seconds and do the conversion on the client side.
 * @param acceptLanguage Accept language(s) that the user choose on the device.
 * If not included or unsupported, the value will default to en-US.
 * Can be weighted with the quality value syntax.
 *
 * Examples:
 * Accept-Language: de
 * Accept-Language: en-US, en;q=0.5
 * Accept-Language: de-DE, de;q=0.9, en-US, en;q=0.7
 *
 * Specification: https://tools.ietf.org/html/rfc7231#section-5.3.5
 *
 * @returns BasePerformanceGraphResponse Ride segments and summary metrics info
 * @throws ApiError
 */

export var getPerformanceGraphInfo = function getPerformanceGraphInfo(api, id, durationSummaryInSeconds, acceptLanguage) {
  var options = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
  var localVarPath = "/api/ride/".concat(id, "/performance_graph_info");
  var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
  var baseOptions;

  if (api.configuration) {
    baseOptions = api.configuration.baseOptions;
  }

  var localVarRequestOptions = _objectSpread(_objectSpread({
    method: 'GET'
  }, baseOptions), options);

  var localVarHeaderParameter = {};
  var localVarQueryParameter = {};

  if (typeof durationSummaryInSeconds !== 'undefined') {
    localVarQueryParameter['duration_summary_in_seconds'] = durationSummaryInSeconds;
  }

  localVarHeaderParameter['Accept-Language'] = String(acceptLanguage);
  localVarUrlObj.query = _objectSpread(_objectSpread(_objectSpread({}, localVarUrlObj.query), localVarQueryParameter), options.query); // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943

  delete localVarUrlObj.search;
  localVarRequestOptions.headers = _objectSpread(_objectSpread({}, localVarHeaderParameter), options.headers);
  var localVarAxiosArgs = {
    url: globalImportUrl.format(localVarUrlObj),
    options: localVarRequestOptions
  };
  var axios = api.axios;

  var axiosRequestArgs = _objectSpread(_objectSpread({}, localVarAxiosArgs.options), {}, {
    url: localVarAxiosArgs.url
  });

  return axios.request(axiosRequestArgs);
};
/**
 * Gets user's personal records
 * List of user's fitness discipline based personal records, the order of fitness discipline is: [Aurora Platform] Running, Circuit, Cycling(if user has cycling personal record) [Non-aurora Platform] Cycling, Running(if user has running personal record), Circuit(if user has circuit personal record).  Within each fitness discipline, the records are ordered by increasing duration with wrap around, with the first record being the first from the following list that the user has a personal record for: 45 min, 30 min, 15 min, 10 min, 60 min. The records include all the durations that user has a personal record for. Empty list of records within the fitness discipline indicate that there is no personal records for that specific fitness discipline, and clients will decide whether to display that fitness discipline with empty records based on the platform. Notice All aurora content will be hidden if hide aurora toggle is ON. This endpoint will return an error is accessed for a private user by someone who does not follow them.
 * @param id
 * @param pelotonPlatform Platform the endpoint is called on. This may hide information from the response (class types, fitness disciplines, classes of certain fitness disciplines, etc.) that should not display on this platform. If this has any other effect on the endpoint, it will be noted in the description.
 *
 * @param acceptLanguage Accept language(s) that the user choose on the device.
 * If not included or unsupported, the value will default to en-US.
 * Can be weighted with the quality value syntax.
 *
 * Examples:
 * Accept-Language: de
 * Accept-Language: en-US, en;q=0.5
 * Accept-Language: de-DE, de;q=0.9, en-US, en;q=0.7
 *
 * Specification: https://tools.ietf.org/html/rfc7231#section-5.3.5
 *
 * @returns any Successful response
 * @throws ApiError
 */

export var getUserPersonalRecords = function getUserPersonalRecords(api, id, pelotonPlatform, acceptLanguage) {
  var options = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
  var localVarPath = "/api/user/".concat(id, "/personal_records");
  var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
  var baseOptions;

  if (api.configuration) {
    baseOptions = api.configuration.baseOptions;
  }

  var localVarRequestOptions = _objectSpread(_objectSpread({
    method: 'GET'
  }, baseOptions), options);

  var localVarHeaderParameter = {};
  var localVarQueryParameter = {};
  localVarHeaderParameter['Peloton-Platform'] = String(pelotonPlatform);
  localVarHeaderParameter['Accept-Language'] = String(acceptLanguage);
  localVarUrlObj.query = _objectSpread(_objectSpread(_objectSpread({}, localVarUrlObj.query), localVarQueryParameter), options.query); // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943

  delete localVarUrlObj.search;
  localVarRequestOptions.headers = _objectSpread(_objectSpread({}, localVarHeaderParameter), options.headers);
  var localVarAxiosArgs = {
    url: globalImportUrl.format(localVarUrlObj),
    options: localVarRequestOptions
  };
  var axios = api.axios;

  var axiosRequestArgs = _objectSpread(_objectSpread({}, localVarAxiosArgs.options), {}, {
    url: localVarAxiosArgs.url
  });

  return axios.request(axiosRequestArgs);
};
/**
 * Updates user's personal records with a reset_date timestamp
 * User will select a date to reset PRs such that PRs will now be selected from workouts taken since this date rather than the user's entire workout history. Returns list of user's fitness discipline based personal records, the order of fitness discipline is: [Aurora Platform] Running, Circuit, Cycling(if user has cycling personal record) [Non-aurora Platform] Cycling, Running(if user has running personal record), Circuit(if user has circuit personal record). Within each fitness discipline, the records are ordered by increasing duration with wrap around, with the first record being the first from the following list that the user has a personal record for: 45 min, 30 min, 15 min, 10 min, 60 min. The records include all the durations that user has a personal record for. Empty list of records within the fitness discipline indicate that there is no personal records for that specific fitness discipline, and clients will decide whether to display that fitness discipline with empty records based on the platform. There may be empty values for each duration, indicating that a user has not taken a workout of that duration since the reset_date timestamp.
 * @param id
 * @param requestBody
 * @param pelotonPlatform Platform the endpoint is called on. This may hide information from the response (class types, fitness disciplines, classes of certain fitness disciplines, etc.) that should not display on this platform. If this has any other effect on the endpoint, it will be noted in the description.
 *
 * @param acceptLanguage Accept language(s) that the user choose on the device.
 * If not included or unsupported, the value will default to en-US.
 * Can be weighted with the quality value syntax.
 *
 * Examples:
 * Accept-Language: de
 * Accept-Language: en-US, en;q=0.5
 * Accept-Language: de-DE, de;q=0.9, en-US, en;q=0.7
 *
 * Specification: https://tools.ietf.org/html/rfc7231#section-5.3.5
 *
 * @returns any Successful response
 * @throws ApiError
 */

export var updateUserPersonalRecords = function updateUserPersonalRecords(api, id, requestBody, pelotonPlatform, acceptLanguage) {
  var options = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};
  var localVarPath = "/api/user/".concat(id, "/personal_records/reset");
  var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
  var baseOptions;

  if (api.configuration) {
    baseOptions = api.configuration.baseOptions;
  }

  var localVarRequestOptions = _objectSpread(_objectSpread({
    method: 'POST'
  }, baseOptions), options);

  var localVarHeaderParameter = {};
  var localVarQueryParameter = {};
  localVarHeaderParameter['Peloton-Platform'] = String(pelotonPlatform);
  localVarHeaderParameter['Accept-Language'] = String(acceptLanguage);
  localVarUrlObj.query = _objectSpread(_objectSpread(_objectSpread({}, localVarUrlObj.query), localVarQueryParameter), options.query); // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943

  delete localVarUrlObj.search;
  localVarRequestOptions.headers = _objectSpread(_objectSpread({}, localVarHeaderParameter), options.headers);
  localVarRequestOptions.data = requestBody;
  var localVarAxiosArgs = {
    url: globalImportUrl.format(localVarUrlObj),
    options: localVarRequestOptions
  };
  var axios = api.axios;

  var axiosRequestArgs = _objectSpread(_objectSpread({}, localVarAxiosArgs.options), {}, {
    url: localVarAxiosArgs.url
  });

  return axios.request(axiosRequestArgs);
};
/**
 * Gets a user's workouts
 * Returns a list containing all workouts. There are a few different ways to search this list First, you can search with to and from, which gets all workouts in that time range There are also two forms of pagination. The older style uses a page number and a limit. The newer style uses a limit along with a before or after parameter. This endpoint will return an error is accessed for a private user by someone who does not follow them. This endpoint is allowed to join with ride which will include ride information in response.
 * @param id
 * @param acceptLanguage Accept language(s) that the user choose on the device.
 * If not included or unsupported, the value will default to en-US.
 * Can be weighted with the quality value syntax.
 *
 * Examples:
 * Accept-Language: de
 * Accept-Language: en-US, en;q=0.5
 * Accept-Language: de-DE, de;q=0.9, en-US, en;q=0.7
 *
 * Specification: https://tools.ietf.org/html/rfc7231#section-5.3.5
 *
 * @param pelotonPlatform Platform the endpoint is called on. This may hide information from the response (class types, fitness disciplines, classes of certain fitness disciplines, etc.) that should not display on this platform. If this has any other effect on the endpoint, it will be noted in the description.
 *
 * @param limit Number of workouts returned per page
 * @param page Page number
 * @param before URL-encoded JSON formatted string containing workout_id and optionally created_at. This will find workouts immediately before the workout specified by workout_id in sort order (which is descending creation time). (This means that it will return workouts cronologically after the one in the parameter.) created_at should be included where possible because it decreases the response time of the endpoint, but is not required. Without URL-encoding, this will look like '{"workout_id": "12312f537b9241caa3c519a5de945f3d", "created_at": "1484749509"}'
 * @param after URL-encoded JSON formatted string containing workout_id and optionally created_at. This will find workouts immediately after the workout specified by workout_id in sort order (which is descending creation time). (This means that it will return workouts cronologically before the one in the parameter.) created_at should be included where possible because it decreases the response time of the endpoint, but is not required. Without URL-encoding, this will look like '{"workout_id": "12312f537b9241caa3c519a5de945f3d", "created_at": "1484749509"}'
 * @param includeBoundary If used with `after` or `before`, this causes the workout_id from the parameter to be include in the response. This does count towards the pagination limit.
 * @param to Start date in ISO 8601[TZ] used to filter workouts. If `to` is provided, but `from` isn't, (or vice versa), it'll be ignored. If `from` is after `to`, a 400 will be returned. Cannot be used in conjunction with page or limit
 * @param from End date in ISO 8601[TZ] used to filter workouts If `to` is provided, but `from` isn't, (or vice versa), it'll be ignored. If `from` is after `to`, a 400 will be returned. Cannot be used in conjunction with page or limit
 * @param statsTo Start date in ISO 8601[TZ] used to filter for which workouts aggregate stats are returned. Can only be used in conjunction with the arguments `to` and `from` If `stats_to` is after `to`, a 400 will be returned
 * @param statsFrom End date in ISO 8601[TZ] used to filter for which workouts aggregate stats are returned. If `from` is after `to`, a 400 will be returned. Can only be used in conjunction with the arguments `to` and `from` If `stats_from` is before `from`, a 400 will be returned
 * @returns any A list of workouts
 * @throws ApiError
 */

export var getUserWorkouts = function getUserWorkouts(api, id, acceptLanguage, pelotonPlatform, limit, page, before, after, includeBoundary, to, from, statsTo, statsFrom) {
  var options = arguments.length > 13 && arguments[13] !== undefined ? arguments[13] : {};
  var localVarPath = "/api/user/".concat(id, "/workouts");
  var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
  var baseOptions;

  if (api.configuration) {
    baseOptions = api.configuration.baseOptions;
  }

  var localVarRequestOptions = _objectSpread(_objectSpread({
    method: 'GET'
  }, baseOptions), options);

  var localVarHeaderParameter = {};
  var localVarQueryParameter = {};

  if (typeof limit !== 'undefined') {
    localVarQueryParameter['limit'] = limit;
  }

  if (typeof page !== 'undefined') {
    localVarQueryParameter['page'] = page;
  }

  if (typeof before !== 'undefined') {
    localVarQueryParameter['before'] = before;
  }

  if (typeof after !== 'undefined') {
    localVarQueryParameter['after'] = after;
  }

  if (typeof includeBoundary !== 'undefined') {
    localVarQueryParameter['include_boundary'] = includeBoundary;
  }

  if (typeof to !== 'undefined') {
    localVarQueryParameter['to'] = to;
  }

  if (typeof from !== 'undefined') {
    localVarQueryParameter['from'] = from;
  }

  if (typeof statsTo !== 'undefined') {
    localVarQueryParameter['stats_to'] = statsTo;
  }

  if (typeof statsFrom !== 'undefined') {
    localVarQueryParameter['stats_from'] = statsFrom;
  }

  localVarHeaderParameter['Accept-Language'] = String(acceptLanguage);
  localVarHeaderParameter['Peloton-Platform'] = String(pelotonPlatform);
  localVarUrlObj.query = _objectSpread(_objectSpread(_objectSpread({}, localVarUrlObj.query), localVarQueryParameter), options.query); // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943

  delete localVarUrlObj.search;
  localVarRequestOptions.headers = _objectSpread(_objectSpread({}, localVarHeaderParameter), options.headers);
  var localVarAxiosArgs = {
    url: globalImportUrl.format(localVarUrlObj),
    options: localVarRequestOptions
  };
  var axios = api.axios;

  var axiosRequestArgs = _objectSpread(_objectSpread({}, localVarAxiosArgs.options), {}, {
    url: localVarAxiosArgs.url
  });

  return axios.request(axiosRequestArgs);
};
/**
 * Get a list of active days for every month in the user's workout history
 * Gets the workout history of the user in the form of a calendar of which days in each month the user has taken a workout. Months are listed in from the current month back to the month of the user's first workout. Months where the user did not take a workout are included with no active days. The day of the workout is based on the date on the user's device when taking the workout
 * @param id User id
 * @param pelotonClientDate The current time accord to the client when the calendar was requested, given in ISO8601 format
 * @returns any Successful response.
 * @throws ApiError
 */

export var getUserWorkoutCalendar = function getUserWorkoutCalendar(api, id, pelotonClientDate) {
  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var localVarPath = "/api/user/".concat(id, "/calendar");
  var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
  var baseOptions;

  if (api.configuration) {
    baseOptions = api.configuration.baseOptions;
  }

  var localVarRequestOptions = _objectSpread(_objectSpread({
    method: 'GET'
  }, baseOptions), options);

  var localVarHeaderParameter = {};
  var localVarQueryParameter = {};
  localVarHeaderParameter['Peloton-Client-Date'] = String(pelotonClientDate);
  localVarUrlObj.query = _objectSpread(_objectSpread(_objectSpread({}, localVarUrlObj.query), localVarQueryParameter), options.query); // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943

  delete localVarUrlObj.search;
  localVarRequestOptions.headers = _objectSpread(_objectSpread({}, localVarHeaderParameter), options.headers);
  var localVarAxiosArgs = {
    url: globalImportUrl.format(localVarUrlObj),
    options: localVarRequestOptions
  };
  var axios = api.axios;

  var axiosRequestArgs = _objectSpread(_objectSpread({}, localVarAxiosArgs.options), {}, {
    url: localVarAxiosArgs.url
  });

  return axios.request(axiosRequestArgs);
};